const FIELD_SELECTORS = {
  desired_start_date: '[name="application[desired_start_date]"]',
  desired_contract_period: '[name="application[desired_contract_period]"]',
  applicant_last_name: '[name="application[applicant][last_name]"]',
  applicant_first_name: '[name="application[applicant][first_name]"]',
  applicant_last_name_kana: '[name="application[applicant][last_name_kana]"]',
  applicant_first_name_kana: '[name="application[applicant][first_name_kana]"]',
  applicant_sex: '[name="application[applicant][sex]"]',
  applicant_birthdate: '[name="application[applicant][birthdate]"]',
  applicant_phone_number: '[name="application[applicant][phone_number]"]',
  applicant_prefecture: '[name="application[applicant][prefecture]"]',
  applicant_city: '[name="application[applicant][city]"]',
  message: '[name="application[message]"]',
  agreed_terms_at: '[name="application[agreed_terms_at]"]',
  agreed_contact_at: '[name="application[agreed_contact_at]"]',
}

const clearErrors = (form) => {
  form.querySelectorAll('[data-shares-field-error]').forEach((element) => {
    element.hidden = true
    element.textContent = ''
  })
  form.querySelectorAll('[aria-invalid="true"]').forEach((element) => {
    element.removeAttribute('aria-invalid')
  })
}

const showErrors = (form, errors) => {
  clearErrors(form)
  const summary = form.querySelector('[data-shares-error-summary]')
  const list = summary?.querySelector('ul')
  if (!summary || !list) return

  list.replaceChildren()
  Object.entries(errors).forEach(([field, messages]) => {
    const messageList = Array.isArray(messages) ? messages : [messages]
    messageList.forEach((message) => {
      const item = document.createElement('li')
      item.textContent = message
      list.appendChild(item)
    })

    const fieldError = form.querySelector(`[data-shares-field-error="${field}"]`)
    if (fieldError) {
      fieldError.textContent = messageList.join('、')
      fieldError.hidden = false
    }
    const selector = FIELD_SELECTORS[field]
    if (selector) {
      form.querySelectorAll(selector).forEach((element) => {
        element.setAttribute('aria-invalid', 'true')
      })
    }
  })

  summary.hidden = false
  summary.focus()
}

const initializeSharesApplyForm = () => {
  document.querySelectorAll('[data-shares-apply-form]').forEach((form) => {
    if (form.dataset.sharesApplyInitialized === 'true') return
    form.dataset.sharesApplyInitialized = 'true'

    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      if (!form.reportValidity()) return

      const submitButton = form.querySelector('[type="submit"]')
      const summary = form.querySelector('[data-shares-error-summary]')
      clearErrors(form)
      if (summary) summary.hidden = true
      form.setAttribute('aria-busy', 'true')
      if (submitButton) submitButton.disabled = true

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
          },
        })

        if (response.status === 201) {
          window.location.assign(form.dataset.completePath)
          return
        }
        if (response.status === 401) {
          window.location.reload()
          return
        }

        const payload = await response.json().catch(() => ({}))
        if (response.status === 422) {
          showErrors(form, payload.errors || { base: ['入力内容を確認してください'] })
        } else if (response.status === 404) {
          showErrors(form, { base: ['この部屋は現在申し込みを受け付けていません'] })
        } else {
          showErrors(form, { base: ['申し訳ありません。時間を置いて再度お試しください'] })
        }
      } catch (_error) {
        showErrors(form, { base: ['通信に失敗しました。接続を確認して再度お試しください'] })
      } finally {
        form.removeAttribute('aria-busy')
        if (submitButton) submitButton.disabled = false
      }
    })
  })
}

document.addEventListener('DOMContentLoaded', initializeSharesApplyForm)
document.addEventListener('turbolinks:load', initializeSharesApplyForm)
